import { MEDIA_QUERIES } from "@constants"
import styled from "styled-components"

export const PlatformHeroGraphicDIV = styled.div`
  --pill-row-height: calc(var(--font-size--6XL) * var(--line-height--tight) + var(--spacing--base-1-25) * 2);

  position: relative;
  overflow: hidden;

  &::after {
    background: linear-gradient(0deg, var(--color--clay-200), rgba(255, 255, 255, 0));
    content: "";
    display: block;
    height: calc(100% - 2 * var(--pill-row-height) - var(--spacing--base-1-5));
    left: 50%;
    position: absolute;
    bottom: 0;
    translate: -50%;
    width: 100vw;
    z-index: -1;
  }

  .pills-wrapper {
    height: calc(var(--pill-row-height) * 2 + var(--spacing--base-1-5));
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    width: 100vw;
    left: 0;
    z-index: 0;
    top: var(--spacing--L);

    &::after {
      background: radial-gradient(139.45% 229.84% at 50% 100%, #FFF 0%, rgba(255, 255, 255, 0.99) 6.67%, rgba(255, 255, 255, 0.96) 13.33%, rgba(255, 255, 255, 0.92) 20%, rgba(255, 255, 255, 0.85) 26.67%, rgba(255, 255, 255, 0.77) 33.33%, rgba(255, 255, 255, 0.67) 40%, rgba(255, 255, 255, 0.56) 46.67%, rgba(255, 255, 255, 0.44) 53.33%, rgba(255, 255, 255, 0.33) 60%, rgba(255, 255, 255, 0.23) 66.67%, rgba(255, 255, 255, 0.15) 73.33%, rgba(255, 255, 255, 0.08) 80%, rgba(255, 255, 255, 0.04) 86.67%, rgba(255, 255, 255, 0.01) 93.33%, rgba(255, 255, 255, 0.00) 100%);
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 1;
    }
  }

  .pills-row {
    display: flex;
    flex-wrap: nowrap;
    gap: 0 var(--spacing--base-1-5);
    left: 0;
    position: absolute;
    top: 0;

    &:nth-child(2) {
      bottom: 0;
      left: auto;
      right: 0;
      top: auto;
    }
  }

  .pill {
    border-radius: var(--pill-row-height);
    display: block;
    margin: 0;
    padding: var(--spacing--base-1-25) var(--spacing--M);
    white-space: nowrap;
  }

  .platform-image--grid {
    align-items: end;

    .gatsby-image-wrapper {
      border-radius: var(--border-radius--M) var(--border-radius--M) 0 0;
      box-shadow: var(--elevation--XL);
      transition: left 0.3s, right 0.3s;
      margin-bottom: -1px;
    }
  }

  .platform-image--inbox {
    grid-area: 1 / 1 / 2 / 7;

    .gatsby-image-wrapper {
      left: var(--spacing--M);
      width: 150vw;
    }

    ${MEDIA_QUERIES.M} {
      grid-area: 1 / 1 / 2 / 13;

      .gatsby-image-wrapper {
        left: 0;
        width: 100%;
      }
    }

    ${MEDIA_QUERIES.L} {
      grid-area: 1 / 2 / 2 / 12;

      .gatsby-image-wrapper {
        width: 100%;
      }
    }
  }

  .platform-image--docs {
    grid-area: 1 / 1 / 2 / 7;
    
    .gatsby-image-wrapper {
      width: 75vw;
    }

    ${MEDIA_QUERIES.M} {
      grid-area: 1 / 1 / 2 / 8;

      .gatsby-image-wrapper {
        left: calc(var(--spacing--L) * -1);
        width: 100%;
      }
    }

    ${MEDIA_QUERIES.L} {
      grid-area: 1 / 1 / 2 / 6;

      .gatsby-image-wrapper {
        left: 0;
        width: 100%;
      }
    }

    ${MEDIA_QUERIES.XL} {
      .gatsby-image-wrapper {
        left: calc(var(--spacing--L) * -1);
      }
    }
  }

  .platform-image--beacon {
    display: flex;
    grid-area: 1 / 1 / 2 / 7;
    justify-content: flex-end;
    
    .gatsby-image-wrapper {
      position: relative;
      right: calc(var(--spacing--L) * -1);
      width: 37.5vw;
    }

    ${MEDIA_QUERIES.M} {
      grid-area: 1 / 9 / 2 / 13;

      .gatsby-image-wrapper {
        right: calc(var(--spacing--L) * -1);
        width: 100%;
      }
    }

    ${MEDIA_QUERIES.L} {
      grid-area: 1 / 10 / 2 / 13;

      .gatsby-image-wrapper {
        right: 0;
        width: 100%;
      }
    }

    ${MEDIA_QUERIES.XL} {
      .gatsby-image-wrapper {
        right: calc(var(--spacing--L) * -1);
      }
    }
  }
`
